import { RichText, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import pnMergetagReplacer from '../../../lib/utils/pnMergeTagReplacer';
import getCallCenterNumber from '../../../store/selectors/getCallCenterNumber';
import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';

type StRichTextItemProps = {
  inheritLinkColor?: boolean;
};

export const StRichText = styled(RichText, {
  shouldForwardProp: (prop) => prop !== 'inheritLinkColor',
})<StRichTextItemProps>(({ inheritLinkColor }) => ({
  '& a': {
    color: inheritLinkColor ? 'inherit' : 'none',
  },
}));

const RichTextWithPnMergeTag = ({ field, cssClassName, inheritLinkColor }: any) => {
  const { sitecoreContext } = useSitecoreContext();
  const callCenterNumber = getCallCenterNumber(sitecoreContext);
  const [content, setContent] = useState(field);

  useEffect(() => {
    if (callCenterNumber.value) {
      const newContent = pnMergetagReplacer(field?.value, String(callCenterNumber.value), true);
      setContent({ ...content, value: newContent });
    }
  }, [callCenterNumber.value]);

  return (
    <StRichText
      field={content}
      className={cssClassName ? cssClassName : ''}
      inheritLinkColor={inheritLinkColor ? inheritLinkColor : false}
    ></StRichText>
  );
};

export default RichTextWithPnMergeTag;
